// Site-wide form behavior, bound once on the document so it also works on
// pages swapped in by client navigation, whose inline scripts never run:
// - data-confirm='Question?' on a button, link or form asks before the click
//   or submit goes through;
// - data-disable-on-submit on a form disables its submit buttons once it
//   submits, so a second click doesn't send it twice.
const SUBMIT_BUTTONS = 'button:not([type=button]):not([type=reset]), input[type=submit], input[type=image]';

export function bindFormSafeguards(rootDocument) {
	const view = rootDocument.defaultView || window;

	function confirmed(element) {
		const question = element.getAttribute('data-confirm');
		return view.confirm(question);
	}

	function onClick(event) {
		const target = event.target instanceof view.Element ? event.target : null;
		const element = target && target.closest('button[data-confirm], input[data-confirm], a[data-confirm]');
		if(element && !confirmed(element)) {
			event.preventDefault();
			event.stopImmediatePropagation();
		}
	}

	function onSubmit(event) {
		const form = event.target;
		if(!(form instanceof view.HTMLFormElement)) {
			return;
		}
		if(form.hasAttribute('data-confirm') && !confirmed(form)) {
			event.preventDefault();
			event.stopImmediatePropagation();
			return;
		}
		if(form.hasAttribute('data-disable-on-submit')) {
			// After the browser has read the form, so the clicked button's value is sent.
			view.setTimeout(() => {
				if(!event.defaultPrevented) {
					form.querySelectorAll(SUBMIT_BUTTONS).forEach((button) => {
						button.disabled = true;
					});
				}
			}, 0);
		}
	}

	// Capture, so a page's own handlers never see a click or submit the visitor cancelled.
	rootDocument.addEventListener('click', onClick, true);
	rootDocument.addEventListener('submit', onSubmit, true);

	return () => {
		rootDocument.removeEventListener('click', onClick, true);
		rootDocument.removeEventListener('submit', onSubmit, true);
	};
}
